import React, { useState } from 'react';
import { submitCareer } from '../services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from '../components/LoadingSpinner';
import career1Img from '../assets/career1.jpeg';
import '../styles/pages.css';

function Career() {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case 'email':
        if (value.length > 100) return 'Email too long (max 100 characters)';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value) ? '' : 'Invalid email format';
      case 'phone':
        if (value.length > 20) return 'Phone number too long (max 20 characters)';
        const phoneRegex = /^[0-9]{10,15}$/;
        return phoneRegex.test(value.replace(/[\s-]/g, '')) ? '' : 'Invalid phone number';
      case 'name':
        if (value.length > 100) return 'Name too long (max 100 characters)';
        return value.trim() ? '' : 'This field is required';
      case 'message':
        if (value.length > 2000) return 'Message too long (max 2000 characters)';
        return value.trim() ? '' : 'This field is required';
      default:
        return '';
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({...formData, [name]: value});
    const error = validateField(name, value);
    setErrors({...errors, [name]: error});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    ['name', 'email', 'phone', 'message'].forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error('Please fix all errors before submitting');
      return;
    }

    setIsSubmitting(true);

    try {
      await submitCareer({
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: formData.phone.trim(),
        message: formData.message.trim()
      });
      toast.success('✅ Application submitted successfully! We will contact you soon.');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setErrors({});
      e.target.reset();
    } catch (error) {
      toast.error(error.message || 'Failed to submit application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <ToastContainer position="top-right" autoClose={5000} />
      {isSubmitting && <LoadingSpinner message="Submitting application..." />}
      <section className="hero">
        <div className="container">
          <h1>Career Opportunities</h1>
          <p>Join our growing team</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <h2 className="section-title">Build Your Career With Us</h2>
          <div className="career-intro">
            <div className="career-intro-img">
              <img src={career1Img} alt="Build Your Career" style={{width: '100%', borderRadius: '10px'}} />
            </div>
            <div className="career-intro-text">
              <p style={{lineHeight: '1.8', textAlign: 'justify'}}>
                We're building a dynamic team of professionals passionate about technology and innovation. If you're looking for a place where your ideas matter and your growth is our priority, we'd love to hear from you.
              </p>
            </div>
          </div>
          <form className="contact-form career-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Full Name *"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? 'error' : ''}
                maxLength="100"
                required
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? 'error' : ''}
                maxLength="100"
                required
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone *"
                value={formData.phone}
                onChange={handleChange}
                className={errors.phone ? 'error' : ''}
                maxLength="20"
                required
              />
              {errors.phone && <span className="error-message">{errors.phone}</span>}
            </div>
            <div className="form-group">
              <textarea
                rows="5"
                name="message"
                placeholder="Tell us about yourself *"
                value={formData.message}
                onChange={handleChange}
                className={errors.message ? 'error' : ''}
                maxLength="2000"
                required
              ></textarea>
              {errors.message && <span className="error-message">{errors.message}</span>}
            </div>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Application'}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Career;
